import { useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { DatasetAssistant } from "datasets/components/assistant/DatasetAssistant";

const DatasetAnalysis = () => {
  const { datasetId } = useParams<{ datasetId: string }>();
  const [searchParams, setSearchParams] = useSearchParams();

  const conversationId = searchParams.get("conversationId");

  const handleConversationChange = useCallback(
    (id: string | null) => {
      setSearchParams(
        (prev) => {
          if (id) {
            prev.set("conversationId", id);
          } else {
            prev.delete("conversationId");
          }
          return prev;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  if (!datasetId) {
    return <div>Dataset not found</div>;
  }

  return (
    <div className="h-[calc(100vh-112px)]">
      <DatasetAssistant
        datasetId={datasetId}
        mode="embedded"
        initialConversationId={conversationId}
        onConversationChange={handleConversationChange}
      />
    </div>
  );
};

export default DatasetAnalysis;
